import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AboutComponent} from './user/components/about/about.component';
import {ListEnterpriseComponent} from './user/components/enterprise/list-enterprise/list-enterprise.component';
import {ListPersonComponent} from './user/components/person/list-person/list-person.component';
import {ListDocumentComponent} from './user/components/document/list-document/list-document.component';
import {VerifierComponent} from './public/components/verifier/verifier.component';
import {ListWorkflowComponent} from './user/components/workflow/list-workflow/list-workflow.component';
import {AuthGuard} from './user/service/guards/auth.guard';
import {LoginComponent} from './user/components/login/login.component';
import {ListJobComponent} from './user/components/job/list-job/list-job.component';
import {
  ListSieCredentialComponent
} from './user/components/sie-credential/list-sie-credential/list-sie-credential.component';
import {VerifierbycodeComponent} from './public/components/verifierbycode/verifierbycode.component';
import {ListAuthorityComponent} from './user/components/authority/list-authority/list-authority.component';
import {ListRoleComponent} from './user/components/role/list-role/list-role.component';
import {ProfileComponent} from './user/components/profile/profile.component';
import {
  RecoverPasswordFirstStepComponent
} from './public/components/recover-password-first-step/recover-password-first-step.component';
import {
  RecoverPasswordSecondStepComponent
} from './public/components/recover-password-second-step/recover-password-second-step.component';
import {
  RecoverPasswordThirdStepComponent
} from './public/components/recover-password-third-step/recover-password-third-step.component';
import {GlobalConfigComponent} from './user/components/global-config/global-config.component';
import {BuyBalanceComponent} from './user/components/balance/buy-balance/buy-balance.component';
import {ViewBalanceComponent} from './user/components/balance/view-balance/view-balance.component';
import {
  DeleteDocumentPermanentelyComponent
} from './user/components/document/delete-document-permanentely/delete-document-permanentely.component';
import {ListInstallerComponent} from './user/components/installer/list-installer/list-installer.component';
import {ReviewComponent} from './public/components/review/review.component';
import {
  ListTsaCredentialComponent
} from './user/components/tsa-credential/list-tsa-credential/list-tsa-credential.component';
import {TempLoginComponent} from './user/components/temp-login/temp-login.component';
import {
  ListInvitedDocumentComponent
} from './user/components/document/list-invited-document/list-invited-document.component';
import {
  ListBatchLoadingComponent
} from './user/components/batch-loading/list-batch-loading/list-batch-loading.component';
import {
  ConsolidatedIOFConsumptionComponent
} from './user/components/reports/consolidated-iof-consumption/consolidated-iof-consumption.component';
import {
  IofConsumptionReportComponent
} from './user/components/reports/iof-consumption-report/iof-consumption-report.component';
import {
  DownloadGroupDocumentComponent
} from './user/components/document/download-group-document/download-group-document.component';
import {ParameterBoardComponent} from './user/components/parameter/parameter-board/parameter-board.component';
import {ReportStorageComponent} from './user/components/reports/report-storage/report-storage.component';
import {ListTemplateComponent} from './user/components/template/list-template/list-template.component';
import {ListAdsComponent} from './user/components/ads/list-ads/list-ads.component';
import {UserRegisterComponent} from './public/components/user-register/user-register.component';
import {DocumentValidatorComponent} from './public/components/document-validator/document-validator.component';
import {ChangePasswordComponent} from './public/components/change-password/change-password.component';
import {WelcomeToSignComponent} from './public/components/welcome-to-sign/welcome-to-sign.component';
import {
  IdentityValidationSignComponent
} from './public/components/identity-validation-sign/identity-validation-sign.component';
import {DocumentViewerComponent} from './public/components/document-viewer/document-viewer.component';
import {AddOrDrawRubricComponent} from './public/components/add-or-draw-rubric/add-or-draw-rubric.component';
import {
  SignedDocumentViewerComponent
} from './public/components/signed-document-viewer/signed-document-viewer.component';
import {
  RequestCertificateOnesignComponent
} from './public/components/request-certificate-onesign/request-certificate-onesign.component';
import {
  RequestOnesignOtpCodeComponent
} from './public/components/request-onesign-otp-code/request-onesign-otp-code.component';
import {
  AcceptTermConditionOnesignComponent
} from './public/components/accept-term-condition-onesign/accept-term-condition-onesign.component';
import {
  RemoteSigningCredentialComponent
} from './public/components/remote-signing-credential/remote-signing-credential.component';
import {BillingServicesComponent} from './user/components/billing/billing-services/billing-services.component';
import {ServicesReportComponent} from './user/components/reports/services-report/services-report.component';
import {
  ServicesReportDetailComponent
} from './user/components/reports/services-report-detail/services-report-detail.component';
import {
  BillingServicesAddComponent
} from './user/components/billing/billing-services-add/billing-services-add.component';
import {
  PersonDataConfirmationComponent
} from './public/components/person-data-confirmation/person-data-confirmation.component';

const APP_ROUTES: Routes = [
  {path: 'about', component: AboutComponent},
  {path: 'enterprise', component: ListEnterpriseComponent, canActivate: [AuthGuard]},
  {path: 'person', component: ListPersonComponent, canActivate: [AuthGuard]},
  {path: 'document', component: ListDocumentComponent, canActivate: [AuthGuard]},
  {path: 'document/:hashIdentifier/verifier', component: VerifierComponent},
  {path: 'document/:hashIdentifier/resources/:hashResource/verifier', component: VerifierComponent},
  {path: 'document/:hashIdentifier/resources/:hashResource/verifier1/:verificationType', component: VerifierComponent},
  {path: 'workflow', component: ListWorkflowComponent, canActivate: [AuthGuard]},
  {path: 'invited-document', component: ListInvitedDocumentComponent, canActivate: [AuthGuard]},
  {path: 'document/:hashIdentifier/people/:personId/sign', component: WelcomeToSignComponent},
  {path: 'document/:hashIdentifier/people/:personId/review', component: WelcomeToSignComponent},
  {path: 'login', component: LoginComponent},
  {path: 'login/:alliancecode', component: LoginComponent},
  {path: 'job', component: ListJobComponent, canActivate: [AuthGuard]},
  {path: 'installer', component: ListInstallerComponent, canActivate: [AuthGuard]},
  {path: 'tsacredential', component: ListTsaCredentialComponent, canActivate: [AuthGuard]},
  {path: 'siecrendential', component: ListSieCredentialComponent, canActivate: [AuthGuard]},
  {path: 'document/verifier', component: VerifierbycodeComponent},
  {path: 'verificar', component: VerifierbycodeComponent},
  {path: 'role', component: ListRoleComponent, canActivate: [AuthGuard]},
  {path: 'authority', component: ListAuthorityComponent, canActivate: [AuthGuard]},
  {path: 'profile', component: ProfileComponent, canActivate: [AuthGuard]},
  {path: 'passwordrecovery', component: RecoverPasswordFirstStepComponent},
  {path: 'verifycoderecovery', component: RecoverPasswordSecondStepComponent},
  {path: 'setuppassword', component: RecoverPasswordThirdStepComponent},
  {path: 'globalconfig', component: GlobalConfigComponent, canActivate: [AuthGuard]},
  {path: 'buy-balance', component: BuyBalanceComponent, canActivate: [AuthGuard]},
  {path: 'billing-services', component: BillingServicesComponent, canActivate: [AuthGuard]},
  {path: 'create-billing', component: BillingServicesAddComponent},
  {path: 'view-balance', component: ViewBalanceComponent, canActivate: [AuthGuard]},
  {path: 'deleteddocuments', component: DeleteDocumentPermanentelyComponent, canActivate: [AuthGuard]},
  {path: 'temp-login', component: TempLoginComponent},
  {path: 'sign-batch-loading', component: ListBatchLoadingComponent, canActivate: [AuthGuard]},
  {path: 'service-report', component: ServicesReportComponent, canActivate: [AuthGuard]},
  {path: 'service-report-detail', component: ServicesReportDetailComponent, canActivate: [AuthGuard]},
  {
    path: 'consolidated-iof-consumption-report',
    component: ConsolidatedIOFConsumptionComponent,
    canActivate: [AuthGuard]
  },
  {path: 'iof-consumption-report', component: IofConsumptionReportComponent, canActivate: [AuthGuard]},
  {path: 'download-group-document', component: DownloadGroupDocumentComponent, canActivate: [AuthGuard]},
  {path: 'parameter-board', component: ParameterBoardComponent, canActivate: [AuthGuard]},
  {path: 'report-storage', component: ReportStorageComponent, canActivate: [AuthGuard]},
  {path: 'templates', component: ListTemplateComponent, canActivate: [AuthGuard]},
  {path: 'ads', component: ListAdsComponent, canActivate: [AuthGuard]},
  {path: 'pdf-validator', component: DocumentValidatorComponent},
  {path: 'change-password', component: ChangePasswordComponent},
  {path: 'person/:hashCode/register', component: UserRegisterComponent},
  {path: 'document/:hashIdentifier/people/:personId/identity-validation', component: IdentityValidationSignComponent},
  {path: 'document/:hashIdentifier/people/:personId/viewer', component: DocumentViewerComponent},
  {path: 'document/:hashIdentifier/people/:personId/confirmation', component: PersonDataConfirmationComponent},
  {path: 'document/:hashIdentifier/people/:personId/add-or-draw-rubric', component: AddOrDrawRubricComponent},
  {path: 'document/:hashIdentifier/people/:personId/document-signed', component: SignedDocumentViewerComponent},
  {
    path: 'document/:hashIdentifier/people/:personId/request-certificate',
    component: RequestCertificateOnesignComponent
  },
  {path: 'document/:hashIdentifier/people/:personId/request-otp-code', component: RequestOnesignOtpCodeComponent},
  {path: 'document/:hashIdentifier/people/:personId/terms-conditions', component: AcceptTermConditionOnesignComponent},
  {path: 'document/:hashIdentifier/people/:personId/signing-credential', component: RemoteSigningCredentialComponent},
  {path: 'document/:hashIdentifier/people/:personId/review-document', component: ReviewComponent},
  {path: '**', pathMatch: 'full', redirectTo: 'login'},
];

@NgModule({
  imports: [RouterModule.forRoot(APP_ROUTES, {useHash: true})],
  exports: [RouterModule]
})

export class AppRoutingModule {

}
